import {Component, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, combineLatest, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {StateService} from "web-shared";
import {LeModalService, LocalizationModel, LocalizationService} from "common-shared";
import {LocalizationEditComponent} from "../localization-edit/localization-edit.component";
import {Table} from "primeng/table";

@Component({
  selector: 'app-localization-list',
  templateUrl: './localization-list.component.html',
  styles: []
})
export class LocalizationListComponent implements OnInit {
  filteredData$: Observable<LocalizationModel[]>;
  @ViewChild(Table) table: Table;
  search$ = new BehaviorSubject<string>(null);
  searchString: string;
  private showTranslationKeysStorageKey = 'Show-Translation-Keys';
  showKeys: boolean = false;

  constructor(public localizationService: LocalizationService, private stateService: StateService, private modalService: LeModalService) {
  }

  ngOnInit(): void {
    this.configureFilter();
  }

  configureFilter(): void {
    this.filteredData$ = combineLatest(
      [this.localizationService.getLocalizationsByLanguage(this.stateService.currentUser$.getValue().Language.Text), this.search$]
    ).pipe(map(([translations, search]) => {
        this.table?.filterGlobal(search, 'contains');
        return translations;
      })
    );
    this.showKeys = localStorage.getItem(this.showTranslationKeysStorageKey) === 'true';
  }

  edit(key: string) {
    let leModalRef = this.modalService.show(LocalizationEditComponent, {initialState: {key: key}});
    leModalRef.onHide$.subscribe(() => {
      this.configureFilter();
    });
  }

  toggleShowKeys() {
    localStorage.getItem(this.showTranslationKeysStorageKey) === 'true' ? localStorage.removeItem(this.showTranslationKeysStorageKey) : localStorage.setItem(this.showTranslationKeysStorageKey, 'true');
    window.location.reload();
  }
}
